import { Avatar } from '@mui/material'
import styled from 'styled-components'

export const AvatarStyles = styled(Avatar)`
  width: 4.2rem;
  height: 4.2rem;
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
`
